<script setup lang="ts">
import { OrderItem } from 'src/core/types/Order';
import { UserInfo } from 'src/core/types/User';
import { nextTick, onMounted, ref } from 'vue';
import axios from 'axios';

const $props = defineProps<{
  orderInfo: OrderItem;
  userInfo: UserInfo;
  generalInfo?: Record<string, any>;
  addressInfo?: Record<string, any>;
}>();

const formHtml = ref(null);
const formContainer = ref<HTMLDivElement | null>(null);

onMounted(() => {
  fetchForm();
});

async function fetchForm() {
  const { data } = await axios.post('/api/shopier-form', {
    orderInfo: $props.orderInfo,
    userInfo: $props.userInfo,
    generalInfo: $props.generalInfo,
    addressInfo: $props.addressInfo,
  });
  if (!data || !data.formHtml) {
    console.error('Form HTML is missing in the response');
    return;
  }
  formHtml.value = data.formHtml;

  await nextTick(() => {
    // const scripts = formContainer.value.querySelectorAll('script');
    // scripts.forEach((oldScript) => {
    //   const newScript = document.createElement('script');
    //   newScript.textContent = oldScript.textContent;
    //   Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
    //   oldScript.replaceWith(newScript);
    // });
  });

  const form = formContainer.value.querySelector('#shopier_payment_form');

  if (form) {
    form.submit();
  }

  formHtml.value = null;
}
</script>

<template>
  <div ref="formContainer" v-html="formHtml"></div>
</template>

<style scoped></style>
